import { Base, base } from "./base"

export type Transforms = Base

export const transforms: Transforms = {
  ...base,
}
